import React, { useState, Fragment } from 'react'
import SingleColor from './SingleColor'

import Values from 'values.js'

function App() {
  const [color, setColor] = useState('')
  const [error, setError] = useState(false)
  const [list, setList] = useState(new Values('#05dbfc').all(10))

  const handleSubmit = (e) => {
    e.preventDefault()
    try {
      let colors = new Values(color).all(10)
      setList(colors)
    } catch (error) {
      setError(true)
      setTimeout(() => {
        setError(false)
      }, 3000)
      console.log(error)
    }

  }
  return (
    <Fragment>
      <section className="container">
        <h3>color generator
        </h3>
        {error ? <p className='error-msg'>Error: You must enter a valid hex value</p> :
          <form onSubmit={handleSubmit}>
            <input
              className={`${error ? 'error' : null} `}
              onChange={(e) => setColor(e.target.value)}
              type="text"
              value={color}
              placeholder='Hex value e.g: #05dbfc '
            />
            <button type='submit' className="btn">submit</button>
          </form>}
      </section>
      <section className="colors">
        {list.map((color, index) => {

          return (
            <SingleColor key={index} {...color} index={index} hexColor={color.hex} />
          )
        })}
      </section>
    </Fragment>
  )
}

export default App
